import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  Home as HomeIcon,
  Person as Person,
  SupervisorAccount as SupervisorAccount,
  Bookmark as Bookmark,
  Today as Today,
  LocalAtm as LocalAtm,
  Details as Details,
  Settings as Settings,
  Laptop as Laptop,
  ArrowBack as ArrowBackIcon,
  Assignment as Assignment,
  AttachMoney as AttachMoney,
  AttachFile as AttachFile,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";

const structure = [
  { id: 0, label: "Pantalla principal", link: "/app/dashboard", icon: <HomeIcon /> },
  {
    id: 1,
    label: "Usuarios",
    link: "/app/user",
    icon: <Person />,
  },
  { id: 2, label: "Socios", link: "/app/partner", icon: <SupervisorAccount /> },
  {
    id: 3,
    label: "Membresias",
    link: "/app/membership",
    icon: <Bookmark />,
  },
  {
    id: 4,
    label: "Sauna",
    link: "/app/sauna",
    icon: <Today />,
  },
  {
    id: 5,
    label: "Productos",
    link: "/app/compras",
    icon: <Details />,
    children: [
      { label: "Stock", link: "/app/compras/product" },
      { label: "Entradas", link: "/app/compras/productEntry" },
      { label: "Salidas", link: "/app/compras/productOutlet" },
    ],
  },
  { id: 7, label: "Punto de Venta", link: "/app/ventas", icon: <Laptop /> },
  {
    id: 8,
    label: "Caja",
    link: "/app/box",
    icon: <LocalAtm />,
    children: [
      { label: "Otras ventas", link: "/app/box/otherSalse" },
      { label: "Ingresos", link: "/app/box/entry" },
      { label: "Gastos", link: "/app/box/egress" },
    ],
  },
  { id: 9, label: "Corte de caja", link: "/app/cashOut", icon: <AttachMoney /> },
  {
    id: 10, label: "Reportes", link: "/app/report", icon: <AttachFile />,
    children: [
      { label: "Egresos", link: "/app/report/egress" },
      { label: "Ingresos", link: "/app/report/entry" },
      { label: "Socios", link: "/app/report/partners" },
      { label: "Productos", link: "/app/report/products" },
      { label: "Cortes de caja", link: "/app/report/cashout" },
    ],
  },
  { id: 11, label: "Configuración", link: "/app/settings", icon: <Settings /> },
];

const secondStructure = [
  { id: 0, label: "Pantalla principal", link: "/app/dashboard", icon: <HomeIcon /> },
  { id: 1, label: "Socios", link: "/app/partner", icon: <SupervisorAccount /> },
  {
    id: 2,
    label: "Membresias",
    link: "/app/membership",
    icon: <Bookmark />,
  },
  {
    id: 3,
    label: "Sauna",
    link: "/app/sauna",
    icon: <Today />,
  },
  { id: 5, label: "Punto de Venta", link: "/app/ventas", icon: <Laptop /> },
  {
    id: 6,
    label: "Caja",
    link: "/app/box",
    icon: <LocalAtm />,
    children: [
      { label: "Entradas", link: "/app/box/entry" },
      { label: "Salidas", link: "/app/box/egress" },
    ],
  },
  { id: 7, label: "Reporte de caja", link: "/app/reportCash", icon: <Assignment /> },
];

const thirdStructure = [
  { id: 0, label: "Pantalla principal", link: "/app/dashboard", icon: <HomeIcon /> },
  { id: 1, label: "Socios", link: "/app/partner", icon: <SupervisorAccount /> },
  {
    id: 2,
    label: "Membresias",
    link: "/app/membership",
    icon: <Bookmark />,
  },
  {
    id: 3,
    label: "Sauna",
    link: "/app/sauna",
    icon: <Today />,
  },
];

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);
  var [user, setUserType] = useState(0);
  var [work, setWork] = useState(0);

  useEffect(function () {
    setUserType(localStorage.getItem("id_token"));
    setWork(localStorage.getItem("work"));
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >

      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {user == 1 ? structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        )) : secondStructure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);